export const STATUS = /** @type {const} */ ({
  APPROVED: 'approved',
  PENDING: 'pending',
  REQUESTED: 'requested',
})
